<template>
  <div class="personalCenter">
      <div class="module">
        <!-- 个人中心导航 -->
        
        <div class="nav-main">
          <personal-nav @isShowContentNav="isShowContentNav"></personal-nav>
        </div>

        <div class="content-main">
            <content-nav v-if="showContentNav && !(pathname === '/personalCenter/Resume' || pathname === '/personalCenter/StartTopic')" ref="contentNav"></content-nav>
            <router-view />
        </div>

      </div>

  </div>
</template>

<script>
import personalNav from './components/personalNav'
import contentNav from './components/contentNav'
export default {
  name: 'personalCenter',
  metaInfo: {
      title: '个人中心 | 让资本赋能企业成长-鲸融网', // set a title
      meta: [{                 // set meta
        name: 'description',
        content: '鲸融网是全维度企业成长服务平台，专注于创业创新、商业管理与资本运营方向，以活动、内容、知识、数据、工具及资源等赋能企业成长。'
      }],
      // link: [{                 // set link
      //   rel: 'asstes',
      //   href: 'https://aaaaaaaaaaa/'
      // }]
    },
  data () {
    return {
      pathname: '',
      showContentNav: true
    }
  },
  mounted () {
    console.log(window.location);
    this.pathname = window.location.pathname
  },
  methods: {
    // 是否显示顶部 ContentNav  页面为个人简历时隐藏
    isShowContentNav(val, name) {
      this.pathname = `/personalCenter/${name}`
      this.showContentNav = val
    },
    info() {
      this.$refs.contentNav.getUserStatisticsInfos()
    },
  },
  filters: {},
  watch: {},
  computed: {},
  components: {
    personalNav,
    contentNav
  }
}
</script>
<style lang="scss" type="text/scss">
  // @import url("../../../common/scss/personalcenter.scss");
  @import '../../../common/scss/personalcenter.scss';
</style>
<style lang="scss" type="text/scss" scope>
body {
  background: #F8F8F8;
}
.personalCenter {
  padding-bottom: 10px;
  background: #F8F8F8;
  .nav-main {
    float: left;
    width: 198px;
  }
  .module {
    margin: auto;
    margin-top: 20px;
    width: 1180px;
    overflow: hidden
  }
  
  .content-main {
    float: right;
    width: 962px;
  }
}
</style>